var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('Filters'),_c('SearchListing')],1),_c('ModalAddToNewWatchlist'),_c('LiveEventNotification',{attrs:{"eventStatus":_vm.liveEventStatus,"course":_vm.liveEventCourse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }